export const addInstallTabs = [
  { id: 'installation', name: 'Installation' },
  { id: 'runlife', name: 'Runlife' },
  { id: 'completion', name: 'Completion' },
  { id: 'systemDesign', name: 'System design' },
  { id: 'failureData', name: 'Failure data' },
  { id: 'installationCost', name: 'Installation cost' },
];
